import { HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import {
    ActivatedRouteSnapshot,
    Resolve,
    RouterStateSnapshot,
} from "@angular/router";
import { BehaviorSubject, Observable } from "rxjs";
import { Budget, ApiGateway } from "cw-backend";
import { SnackBarService } from "cw-utils";

@Injectable()
export class BudgetEditProvider implements Resolve<any> {
    routeParams: any;
    state: any;
    onDataChanged: BehaviorSubject<any>;
    budget: Budget;

    constructor(public gw: ApiGateway, public snackBar: SnackBarService) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        return new Promise((resolve, reject) => {
            Promise.all([this.getBudget()]).then(() => {
                resolve(true);
            }, reject);
        });
    }

    getBudget(): Promise<any> {
        return new Promise((resolve, reject) => {
            let data = this.checkLastModifications();
            if (data && data.id == this.routeParams.id) {
                this.budget = data;
                this.onDataChanged.next(this.budget);
                resolve(this.budget);
            } else if (this.routeParams.id === "novo") {
                this.onDataChanged.next(false);
                resolve(false);
            } else {
                this.gw.get("budget/" + this.routeParams.id).subscribe({
                    next: (res: Budget) => {
                        this.budget = res;
                        this.onDataChanged.next(this.budget);
                        resolve(res);
                    },
                    error: (err: any) => {
                        reject(err);
                    },
                });
            }
        });
    }

    insert(budget): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post("budget/", budget).subscribe({
                next: (response: HttpResponse<any>) => {
                    resolve(response);
                    this.snackBar.successMessage(response.body.message);
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }

    insertProtocol(budget): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post("protocol/", budget).subscribe({
                next: (response: HttpResponse<any>) => {
                    resolve(response);
                    this.snackBar.successMessage(response.body.message);
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }

    insertBudgetItem(budgetItem): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post("budget/budgetItem", budgetItem).subscribe({
                next: (response: HttpResponse<any>) => {
                    resolve(response);
                    this.snackBar.successMessage(response.body.message);
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }

    edit(budget): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post("budget/", budget).subscribe({
                next: (response: HttpResponse<any>) => {
                    resolve(response);
                    this.snackBar.successMessage(response.body.message);
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }

    delete(budget): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.delete("budget/" + budget.id).subscribe({
                next: (response: HttpResponse<any>) => {
                    resolve(response);
                    this.snackBar.successMessage(response.body.message);
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }

    cancelBudget(id:any){
         return new Promise((resolve, reject) => {
            this.gw.put("budget/cancel/" + id).subscribe({
                next: (response: HttpResponse<any>) => {
                    resolve(response);
                    this.snackBar.successMessage(response.body.message);
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }

    deleteItem(budget): Promise<any> {
        console.log("🚀 ~ BudgetEditProvider ~ deleteItem ~ budget:", budget);
        return new Promise((resolve, reject) => {
            this.gw.delete("budget/budgetItem/" + budget.id).subscribe({
                next: (response: HttpResponse<any>) => {
                    resolve(response);
                    this.snackBar.successMessage(response.body.message);
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }

    checkLastModifications(): Budget {
        let wasLocked = JSON.parse(localStorage.getItem("session_locked"));
        let data;
        if (wasLocked) {
            data = JSON.parse(localStorage.getItem("last_modification"));
            localStorage.removeItem("session_locked");
        }
        return data;
    }

    budgetExecuted(budgetId: number, performerId: number): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .post(
                    `budget/budgetExecuted/${budgetId}/${performerId}`,
                    {}
                )
                .subscribe({
                    next: (response: HttpResponse<any>) => {
                        resolve(response);
                        this.snackBar.successMessage(response.body.message);
                    },
                    error: (err: any) => {
                        reject(err);
                    },
                });
        });
    }
}
